import { render, staticRenderFns } from "./LightboxBeforeAfterCard.vue?vue&type=template&id=710b87fe&scoped=true&"
import script from "./LightboxBeforeAfterCard.vue?vue&type=script&lang=js&"
export * from "./LightboxBeforeAfterCard.vue?vue&type=script&lang=js&"
import style0 from "./LightboxBeforeAfterCard.vue?vue&type=style&index=0&id=710b87fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710b87fe",
  null
  
)

export default component.exports